import * as React from "react";
import Component from "../../AbstractComponent";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { connect } from "react-redux";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import UnusedPaymentsWillMount from "../../../Middleware/Middlewares/UnusedPaymentsWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { SnoozeDialog } from "../../Partials/Dialog/SnoozeDialog";
import  PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";
import Constants from "../../../Action/Constants";
import Time from "../../../Time/Time";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import * as ReactTooltip from "react-tooltip";
import { UndoSettleWithSavingsDialog } from "../../Partials/Dialog/UndoSettleWithSavingsDialog";
import Memo from "../../Partials/Memo/Memo";
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import PaymentCounterpartyDescriptionInfoForList from "../../Partials/Payment/PaymentCounterpartyDescriptionInfoForList";
import { buildAuthRedirect } from "../../../Ponto/buildAuthRedirect";
import Log from "../../../Log/Log";
import Translator from "../../../Translation/Translator";
import PaymentCreateDialog from "../../Partials/Dialog/PaymentCreateDialog";

class Unused extends Component {
  protected selectedPayment: PaymentInterface;
  protected selectedPaymentIndex: number;
  protected paginatorPath: string;
  public noteField: null;
  protected timerId: any;
  protected fileInput;

  protected middlewares: MiddlewareInterface[] = [
    UnusedPaymentsWillMount
  ];

  public state = {
    anchorEl: null,
    payments: [],
    unusedPayments: [],
    isFetching: true,
    filterValue: "",
    agencyBankAccountId: "all",
    filter: "unused",
    paymentsCount: 0,
    unusedPaymentsCount: 0,
    paymentToDelete: null,
    isPaymentRemovePopupOpen: false,
    isPaymentUnSettlePopupOpen: false,
    isPaymentUnlinkPopupOpen: false,
    isSaving: false,
    dateFilter: null,
    cannotDeleteSavingsPaymentDialog: false,
    searchInProgress: false,
    paymentToAddNote: null,
    note: "",
    memoPopupOpen: false,
    includeSnoozedFilter: false,
    snoozePaymentDialogOpen: false,
    selectedPayment: null,
    isUndoSavingsPopupOpen: false,
    isBankTransactionsDilaogOpen: false,
    isDialogOpen: false,
    isBankTransFileRemoveOpen: false,
    transactionFile: null,
    unusedSnoozedPaymentsCount: 0,
    pontoRedirectError: null,
    isPaymentCreatePopupOpen: false,
    isPontoRequesting: false,
    pontoAnchorEl: null,
    openPontoMenu: false,
    showConnectNoBankAccountDialog: false,
  }

  constructor(public props) {
    super(props);

    this.fileInput = React.createRef();
  }

  public componentWillReceiveProps(nextProps) {
    // Fetch all payments again if there is a change on payments
    // So user on different screen can see the changes.
    // Socket logic without sockets
    if (!this.props?.payments?.requestsOutdated && nextProps?.payments?.requestsOutdated) {
      this.fetchFirstUnusedPayments();
    }
  }

  public fetchFirstUnusedPayments = (callback?) => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      agencyBankAccount: this.state.agencyBankAccountId,
      filterValue: this.state.filterValue,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      dashboard: 1,
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };

    if (!this.state.includeSnoozedFilter) {
      payload.isSnoozed = 0;
    } else {
      payload.isSnoozed = 1;
    }

    if (!!this.state.dateFilter) {
      payload.date = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        this.fetchFirstSnoozedUnusedPaymentsCount();

        if (!this.state.includeSnoozedFilter) {
          this.props.dispatch({
            type: Constants.GLOBAL_SAVE_UNUSED_PAYMENTS_COUNT,
            payload: {
              dashboardPaymentsCount: data.count
            }
          })
        } else {
          this.props.dispatch({
            type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
            payload: {
              ...payload,
              isSnoozed: 0
            },
            onSuccess: (data) => {
              this.props.dispatch({
                type: Constants.GLOBAL_SAVE_UNUSED_PAYMENTS_COUNT,
                payload: {
                  dashboardPaymentsCount: data.count
                }
              })
            }
          });
        }

        this.setState({
          searchInProgress: false,
          unusedPayments: data.payments,
          unusedPaymentsCount: data.count,
          isFetching: false
        }, () => {
          if (typeof callback === "function") {
            callback();
          }
        })
      }
    });
  }

  public fetchFirstSnoozedUnusedPaymentsCount = () => {
    const payload: any = {
      firstItem: 0,
      lastItem: 0,
      agencyBankAccount: this.state.agencyBankAccountId,
      filterValue: this.state.filterValue,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      dashboard: 1,
      isSnoozed: 1
    };

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_NOT_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        this.setState({
          unusedSnoozedPaymentsCount: data.count,
          isFetching: false
        })
      },
      onError: () => {
        this.setState({
          isFetching: false
        })
      },
    });
  }

  public fetchFilterUnusedPayments = () => {
    const payload: any = {
      agencyBankAccount: this.state.agencyBankAccountId,
      filterValue: this.state.filterValue,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      dashboard: 1,
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };

    if (!!this.state.dateFilter) {
      payload.date = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: data => {
        this.setState({
          unusedPayments: data.payments,
          unusedPaymentsCount: data.count
        })
      }
    })
  }

  public fetchPayments = () => {
    if (this.state.filter === "unused") {
      const payload: any = {
        firstItem: !!this.state.unusedPayments ?  this.state.unusedPayments.length : 0,
        lastItem: !!this.state.unusedPayments && this.state.unusedPayments ?
                                                  this.state.unusedPayments.length + this.props.app.defaultPaginationAmount : 0,
        agencyBankAccount: this.state.agencyBankAccountId,
        filterValue: this.state.filterValue,
        removed: 0,
        isAfterStartDate: 1, // do not fetch charges before start date
        dashboard: 1
      };

      if (!!this.state.dateFilter) {
        payload.date = this.state.dateFilter;
      }

      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const unusedPaymentsArr: PaymentInterface[] = !!this.state.unusedPayments ?
                                          [...this.state.unusedPayments, ...data.payments] : [...data.payments];

          this.setState({
            unusedPayments: unusedPaymentsArr,
            unusedPaymentsCount: data.count
          });
        }
      });
    }
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    }, () => {
      this.fetchFirstUnusedPayments();
    });
  }

  public getAmountsOfFilteredPayments = (filter: string): number => {
    switch (filter) {
      case "unused":
        return this.state.unusedPaymentsCount;
      default:
        return;
    }
  }

  public getFilteredPayments = (filter: string): PaymentInterface[] => {
    let payments = [];

    switch (filter) {
      case "unused":
        payments = [...this.state.unusedPayments]
                .filter((payment: PaymentInterface) => payment.removed === false);
        break;
      default:
        break;
    }

    return payments;
  }

  public delete = () => {
    const paymentToDelete: PaymentInterface = this.state.paymentToDelete;
    if (paymentToDelete?.paymentType?.id === PaymentTypeContainer.pickIdFromLabel("Savings_account")){
      return this.setState({
        isPaymentRemovePopupOpen: false,
        cannotDeleteSavingsPaymentDialog: true
      });
    }
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_DELETE_START,
      payload: {
        payment: paymentToDelete
      },
      onSuccess: () => {
        this.fetchFirstUnusedPayments();

        this.setState({
          isSaving: false,
          isPaymentRemovePopupOpen: false,
          paymentDelete: null
        });
      },
      onError: () => {
        this.setState({
          isSaving: false,
          isPaymentRemovePopupOpen: false,
          paymentDelete: null
        });
      }
    });
  }

  public unlink = (): any => {
    const payment: PaymentInterface = this.state.paymentToDelete;

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_UNLINK_START,
      payload: {
        payment: payment
      },
      onSuccess: () => {
        this.fetchFirstUnusedPayments();

        this.setState({isPaymentUnlinkPopupOpen: false, isSaving: false});
      },
      onError: () => {
        this.setState({
          isPaymentUnlinkPopupOpen: false,
          isSaving: false
        });
      }
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isPaymentRemovePopupOpen: false,
      isPaymentUnlinkPopupOpen: false,
      isPaymentUnSettlePopupOpen: false
    })
  }

  protected openMenu = (event: any, payment: PaymentInterface, index: number): void => {
    this.selectedPayment = payment;
    this.selectedPaymentIndex = index;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.selectedPayment = null;
    this.selectedPaymentIndex = null;

    this.setState({
      anchorEl: null
    })
  }

  public unSettle = (): any => {
    const payment: PaymentInterface = this.state.paymentToDelete;

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_UNSETTLE_START,
      payload: {
        payment: payment
      },
      onSuccess: () => {
        this.fetchFirstUnusedPayments();

        this.setState({isPaymentUnSettlePopupOpen: false, isSaving: false});
      },
      onError: () => {
        this.setState({
          isPaymentUnSettlePopupOpen: false,
          isSaving: false
        });
      }
    });
  }

  public saveScrollPosition = () => {
    var top  = window.pageYOffset || document.documentElement.scrollTop;

    this.props.dispatch({
      type: Constants.DASHBOARD_PAYMENTS_LIST_POSITION_SAVE,
      payload: {
        position: top
      }
    });
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public renderPaymentMemoIcon = (payment: PaymentInterface) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <span>
          <span data-tip={this.getTipText(payment?.note)}>
          <div className={`icon ${payment?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
              onClick={e => {
                e.stopPropagation();
                this.openMemoPopup(payment);
              }}
            >
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </span>
      </div>
    );
  }

  public renderPaymentSnoozeIcon = (payment: PaymentInterface) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <div className={`icon ${payment?.isSnoozed ? "icon-ic-schedule" : "icon-ic-watch-later" }`}
          onClick={e => {
            e.stopPropagation();

            if(payment?.isSnoozed) {
              this.snoozePayment(payment);
            } else {
              this.setState({
                selectedPayment: payment,
                snoozePaymentDialogOpen: true
              })
            }
          }}
        >
        </div>
      </div>
    );
  }

  public snoozePayment = (selectedPayment: PaymentInterface) => {
    if(!selectedPayment) {
      return;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_SNOOZE_UPDATE_START,
        payload: {
          snoozeDate: !selectedPayment.isSnoozed ? Time.formatOrNull(Time.nextDayFromDate(new Date())) : null,
          paymentId: selectedPayment?.id
        },
        onSuccess: () => {
          this.setState({
            anchorEl: null,
            isSaving: false,
          },() => {
            this.fetchFirstUnusedPayments();
          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }


  public openMemoPopup = (payment: PaymentInterface) => {
    this.setState({
      paymentToAddNote: payment, 
      note: payment?.note, 
      memoPopupOpen: true, 
      anchorEl: null 
    });
  }
  public saveDraft = (message) => {
    this.setState({
    note: message,
  })}

  public saveReminder = (payment: PaymentInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_START,
        payload: {
          paymentId: payment?.id,
          payment: {note: this.state.note},
          updateMemo: true
        },
        onSuccess: () => {
          // need this to update charge from the list immediately
          this.fetchFirstUnusedPayments();

          this.setState({
            isSaving: false, 
            memoPopupOpen: false
          })
        },
        onError: () => {
          this.setState({isSaving: false});

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("memo-can-not-be-updated"),
              type: "warning"
            }
          });
        }
      });
    });
  }

  public removeReminder = (payment: PaymentInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_START,
        payload: {
          paymentId: payment?.id,
          payment: {note: ""},
          removeMemo: true
        },
        onSuccess: () => {
          // need this to update charge from the list immediately
          this.fetchFirstUnusedPayments();
          
          this.setState({isSaving: false, memoPopupOpen: false})
        },
        onError: () => {
          this.setState({isSaving: false});
        }
      });
    });
  }

  public renderPaymentTypeIcon = (payment: PaymentInterface) => {
    if(!payment){
      return <div></div>
    }
    let paymentTypeIcon;
    const isSettle = payment?.isSettle;
    const hasSettlementType = payment?.paymentType?.id === PaymentTypeContainer.pickIdFromLabel("Settlement");
    const hasSavingsType = payment?.paymentType?.id === PaymentTypeContainer.pickIdFromLabel("Savings_account");

    if(isSettle || hasSettlementType) {
      paymentTypeIcon = "icon-ic-settle-1";
    } else if(payment?.isRefunded) {
      paymentTypeIcon = "icon-ic-replay";
    } else if(hasSavingsType) {
      paymentTypeIcon = "icon-ic-savings";
    } else {
      paymentTypeIcon = "";
    }

    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <span>
          <div className={`icon ${paymentTypeIcon}`}></div>
        </span>
      </div>
    );
  }

  public changeIncludeSnoozedFilter = () => {
    this.setState({
      includeSnoozedFilter: !this.state.includeSnoozedFilter
    }, () => {
      this.fetchFirstUnusedPayments();
    });

    this.props.dispatch({
      type: Constants.DASHBOARD_PAYMENTS_LIST_CHECK_FILTER,
      payload: {
        includeSnoozedFilterUnusedPyaments: !this.state.includeSnoozedFilter,
      }
    });
  }

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  }

  public getPayments = () => {
    return this.getFilteredPayments(this.state.filter)
      .map((payment: PaymentInterface, index: number) => {
        if (!payment) {
          return;
        }
        let color = "#43A047";

        if (payment.amountUsed < payment.amount) {
          if (payment.amountUsed === 0) {
            color = "#F44336";
          } else {
            color = "#F5A623";
          }
        }

        return (
          <TableRow
            hover
            key={`payment-${index}`}
            className={`clickable-entity`}
            onClick={() => {
              this.saveScrollPosition();

              this.props.dispatch({
                type: Constants.PAGE_BANK_TRANSACTIONS_LIST_OF_NEXT_PAYMENTS_UPDATE,
                payload: {
                  payments: this.getFilteredPayments(this.state.filter),
                  index: this.getFilteredPayments(this.state.filter).findIndex(pmnt => pmnt?.id === payment?.id)
                }
              });

              this.redirect(`/app/payment/update/${payment.id}`);
            }}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  style={{color: color}}
                  className="icon icon-ic-payment"
                ></div>
              </div>
            </TableCell>
            <TableCell style={{width: "15%"}}>{this.formatter.formatDate(payment.dateOfThePayment)}</TableCell>
            <TableCell style={{width: "35%", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "300px"}}>
              <PaymentCounterpartyDescriptionInfoForList payment={payment} />
            </TableCell>
            <TableCell style={{width: "10%"}}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "80px",
                  flexDirection: "column"
                }}
              >
                {
                  payment?.isSnoozed &&
                  <div className="list-label creation-type-label" >
                    {this.trans("label-snoozed")}
                  </div>
                }
                {
                  !payment?.removed && payment?.hasTransaction && !payment?.isProcessed &&
                  <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="list-label creation-type-label red">
                      {this.trans("to-verify")}
                    </div>
                  </div>
                }
              </div>
            </TableCell>
            <TableCell style={{width: "5%"}}>
              {this.renderPaymentSnoozeIcon(payment)}
            </TableCell>
            <TableCell style={{width: "5%"}}>
              {this.renderPaymentMemoIcon(payment)}
            </TableCell>
            <TableCell style={{width: "5%"}}>
              {this.renderPaymentTypeIcon(payment)}
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "20%" }}>
              <div style={{display: "inline-flex", flexDirection: "column"}}>
                <span>{payment.paymentClass.id == PaymentClassContainer.pickIdFromLabel("Payable")  && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(payment.amount, payment.currency)}</span>
                {this.renderPaymentAmountHint(payment)}
              </div>
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, payment, index)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedPayment && this.selectedPayment.id === payment.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.redirect(`/app/payment/update/${this.selectedPayment.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {            
                      if(this.selectedPayment?.isSnoozed) {
                        this.snoozePayment(this.selectedPayment);
                      } else {
                        this.setState({
                          selectedPayment: payment,
                          snoozePaymentDialogOpen: true
                        })
                      }
                    }}
                  >
                    <ListItemIcon><div className={`icon ${this.selectedPayment?.isSnoozed ? "icon-ic-schedule" : "icon-ic-watch-later" } aligned`}></div></ListItemIcon>
                    <ListItemText>{this.selectedPayment?.isSnoozed ? this.trans("unsnooze") : this.trans("snooze")}</ListItemText>
                  </MenuItem>

                  <MenuItem
                    key={`add-memo-btn`}
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                        action: "remove",
                        entityName: "payment",
                        entity: this.selectedPayment
                      })) {
                          this.openIsBusyPopup();
                          this.setState({anchorEl: null})
                        } else {
                          this.openMemoPopup(this.selectedPayment)
                        }
                      }
                    }
                  >
                    <ListItemIcon><div className="icon icon-ic-memo aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open-memo")}</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                        action: "remove",
                                        entityName: "payment",
                                        entity: this.selectedPayment
                                      })) {
                        this.openIsBusyPopup();
                        this.setState({anchorEl: null})
                      } else {
                        this.setState({isPaymentRemovePopupOpen: true, paymentToDelete: this.selectedPayment, anchorEl: null});
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                  
                  {
                    this.selectedPayment?.isReferencedToSavings &&
                      <MenuItem
                        button
                        key={`add-remove-btn`}
                        onClick={() => {
                          if (this.checkProcessIsBusy({
                            action: "remove",
                            entityName: "payment",
                            entity: this.selectedPayment
                          })) {
                              this.openIsBusyPopup();
                              this.setState({anchorEl: null})
                            } else {
                              this.setState({
                                isUndoSavingsPopupOpen: true,
                                anchorEl: null
                              })
                            }
                          }
                        }
                      >
                      <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                      <ListItemText>{this.trans("menuitem-undo-settle-with-savings")}</ListItemText>
                    </MenuItem>
                  }
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public closeDialog = () => {
    this.setState({
      isDialogOpen: false
    });
  }

  public upload = (e: any): any => {
    const file = e.target.files[0];

    this.setState({
      isBankTransactionsDilaogOpen: false
    });

    this.props.dispatch({
      type: Constants.PAGE_BANK_TRANSACTIONS_SET_TITLE,
      payload: {
        title: this.trans("uploading")
      }
    });

    this.props.dispatch({
      type: Constants.PAGE_BANK_TRANSACTIONS_OPEN_DIALOG
    });

    this.setState({
      isDialogOpen: true
    });

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      this.props.dispatch({
        type: Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_START,
        payload: {
          transactionFile: true,
          result: reader.result,
          file: file
        },
        onSuccess: transactionFile => {
          this.setState({
            transactionFile: transactionFile
          }, this.forceUpdate);
        },
        onError: () => {
          this.props.dispatch({
            type: Constants.PAGE_BANK_TRANSACTIONS_CLOSE_DIALOG
          });

          this.setState({
            isDialogOpen: false
          });
        }
      });
    };

    e.target.value = null;
  }

  public renderDialogContent = (): any => {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    // Uploading
    if (!!fileDetails && fileDetails.state === 1) {
      return (
        <div style={{ textAlign: "center" }}>
          <p>{this.trans("mt940-is-uploading")}</p>
          <CircularProgress size={40} thickness={2} />
        </div>
      );
    }

    // Processing
    if (!!fileDetails && fileDetails.state === 2) {
      if (!!fileDetails && fileDetails.current !== fileDetails.total) {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
          this.setState({
            isDialogOpen: false
          });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("mt-940-uploading-is-crashed"),
              type: "error"
            }
          });
        }, 30000);
      }

      return (
        <div style={{ textAlign: "center" }}>
          <p>{this.trans("mt-940-is-processing")}</p>
          <p>{this.trans("processing-x-of-y", { x: !!fileDetails && fileDetails.current, y: !!fileDetails && fileDetails.total })}</p>
          <div style={{padding: "0 24px"}}>
            <LinearProgress
              variant="determinate"
              value={100 / (!!fileDetails && fileDetails.total) * (!!fileDetails && fileDetails.current)}
            />
          </div>
        </div>
      );
    }

    // Success
    if (!!fileDetails && fileDetails.state === 3) {
      clearTimeout(this.timerId);

      return (
        <div>
          <p>{this.trans("mt-940-processing-finished-1")}</p>
            <ul>
              <li>
                <p>{this.trans("mt-940-processing-finished-total-count-payments", {count: !!fileDetails && fileDetails.current})}</p>
              </li>
              <li>
                <p>{this.trans("mt-940-processing-finished-created-count-payments", {count: !!fileDetails && fileDetails.countOfCreatedPayments})}</p>
              </li>
              {
                !!fileDetails && !!fileDetails.countOfExistingPayments && (
                  <li>
                    <p>{this.trans("mt-940-processing-finished-existing-count-payments", {count: !!fileDetails && fileDetails.countOfExistingPayments})}</p>
                  </li>
                )
              }
              {
                !!fileDetails && !!fileDetails.countOfNotRecognizedPayments && (
                  <li>
                    <p>{this.trans("mt-940-processing-finished-not-recognized-count-payments", {count: !!fileDetails && fileDetails.countOfNotRecognizedPayments})}</p>
                  </li>
                )
              }
            </ul>
          <p>{
            this.props.component.error || (!!fileDetails && fileDetails.state === 3 && fileDetails.countOfCreatedPayments === 0) ? this.trans("mt-940-processing-finished-2-close") :
            // this.trans("mt-940-processing-finished-2")
            ""
            }</p>
        </div>
      );
    }

    // Fail
    if (this.props.component.error) {
      return (
        <div>
          {this.image.getAvatar("info", { size: 75 })}
          <p>{this.props.component.translatedMessage}</p>
        </div>
      );
    }
  }

  public determineTitle = (): any => {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    if (!!fileDetails && fileDetails.disableButton === true) {
      return this.trans("title-please-wait");
    }

    if (this.props.component.error || (!!fileDetails && fileDetails.state === 3 && fileDetails.countOfCreatedPayments === 0)) {
      return this.trans("button-close");
    }

    return this.trans("button-continue");
  }

  public close = (): any => {
    this.setState({
      isDialogOpen: false
    });
  }

  public continue = (): any => {
    this.close()

    this.fetchFirstUnusedPayments(() => {
      window.scrollTo({
        top: this.props.app?.dashboardPaymentsListPosition
      });
    });
  }

  public closeBankTransactionsDialog = () => {
    this.setState({
      isBankTransactionsDilaogOpen: false,
    })
  }

  public openBankTransactionsDilaog = () => {
    this.setState({
      isBankTransactionsDilaogOpen: true,
    })
  }

  public openPaymentCreatePopup = () => {
    this.setState({ isPaymentCreatePopupOpen: true });
  }

  private getPontoDefaultBankAccount(): any {
    const bankAccounts = this.getAgencyBankAccounts() || [];
    return bankAccounts.find((a: any) => a?.isDefault) || null;
  }

  private getPontoBankEntry(): any {
    const pontoIntegration = this.props?.app?.pontoIntegration;
    const defaultBankAccount = this.getPontoDefaultBankAccount();
    if (!pontoIntegration || !pontoIntegration.bankAccounts || !defaultBankAccount) return null;
    return pontoIntegration.bankAccounts.find((e: any) => e.id === defaultBankAccount.id) || null;
  }

  private getPontoAccountId(): string {
    return this.getPontoDefaultBankAccount()?.accountId || "";
  }

  public handlePontoConnectClick = () => {
    const defaultBankAccount = this.getPontoDefaultBankAccount();
    if (!defaultBankAccount) {
      this.setState({ showConnectNoBankAccountDialog: true });
      return;
    }
    this.setState({ isPontoRequesting: true });
    this.props.dispatch({
      type: Constants.GLOBAL_PONTO_SYNCHRONIZE,
      payload: { bankAccountId: defaultBankAccount.id },
      onSuccess: () => this.setState({ isPontoRequesting: false }),
      onError: () => this.setState({ isPontoRequesting: false }),
    });
  }

  public handlePontoSyncClick = () => {
    const defaultBankAccount = this.getPontoDefaultBankAccount();
    if (!defaultBankAccount) return;
    this.setState({ isPontoRequesting: true });
    this.props.dispatch({
      type: Constants.GLOBAL_PONTO_SYNCHRONIZE,
      payload: { bankAccountId: defaultBankAccount.id },
      onSuccess: () => this.setState({ isPontoRequesting: false }),
      onError: () => this.setState({ isPontoRequesting: false }),
    });
  }

  public handlePontoRevokeAccess = () => {
    this.setState({ openPontoMenu: false, pontoAnchorEl: null });
    this.props.dispatch({
      type: Constants.GLOBAL_PONTO_REVOKE_ACCESS,
      onSuccess: () => {},
      onError: () => {},
    });
  }

  public closePontoAuthRequiredDialog = () => {
    this.props.dispatch({
      type: Constants.PONTO_AUTHORIZATION_REQUIRED,
      payload: null,
    });
  }

  public closePontoAuthInProgressDialog = () => {
    this.props.dispatch({
      type: Constants.PONTO_AUTHORIZATION_IN_PROGRESS,
      payload: null,
    });
  }

  public closePontoSyncErrorDialog = () => {
    this.props.dispatch({
      type: Constants.PONTO_SYNC_ERROR,
      payload: null,
    });
  }

  public closePontoRevokeErrorDialog = () => {
    this.props.dispatch({
      type: Constants.PONTO_REVOKE_ERROR,
      payload: null,
    });
  }

  public navigateToPontoAuth = async (authUrl: string) => {
    const url = buildAuthRedirect(authUrl);
    const res = await fetch(url, { redirect: "manual" });
    if (res.type === "opaqueredirect") {
      window.location.href = url;
      return;
    }
    this.props.dispatch({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: this.trans("ponto_reauth_connect_error"),
        type: "error",
      },
    });
  }

  private getPontoTranslationForFailureReason(reason: string): string {
    const candidateKey = `ponto_sync_failure_reason_${reason}`;
    const translated = Translator.trans(candidateKey, {}, "", false);
    if (translated.indexOf("[MISSING]") === 0) {
      const bankEntry = this.getPontoBankEntry();
      Log.warn("Unrecognized Ponto sync failure reason — fallback used", {
        reason,
        bankAccountId: this.getPontoDefaultBankAccount()?.id,
        lastDateOfFailedSync: bankEntry?.lastDateOfFailedSync,
      });
      return this.trans("ponto_sync_failure_reason_fallback");
    }
    return translated;
  }

  private renderPontoStatusLine(): string | null {
    const pontoIntegration = this.props?.app?.pontoIntegration;
    const bankEntry = this.getPontoBankEntry();

    const isPontoAuthorizing = pontoIntegration?.status === "authorizing";
    const isPontoDisconnected = pontoIntegration?.status === "disconnected";
    const isPontoConnected = !!bankEntry && !isPontoDisconnected;
    const isSyncPending = bankEntry?.status === "sync_pending";
    const isSyncFailed = bankEntry?.status === "sync_failed";
    const isConnectedNoSync = bankEntry?.status === "connected";

    if (isPontoAuthorizing) return this.trans("ponto_status_authorizing");
    if (!isPontoConnected) return null;

    if (isSyncPending) return this.trans("ponto_status_sync_pending");

    if (isSyncFailed) {
      if (bankEntry.lastDateOfFailedSync) {
        const datetime = this.formatter.formatTimeAndDate(new Date(bankEntry.lastDateOfFailedSync));
        if (bankEntry.lastSyncFailureReason) {
          const reason = this.getPontoTranslationForFailureReason(bankEntry.lastSyncFailureReason);
          return this.trans("ponto_status_sync_failed_at_with_reason", { datetime, reason });
        }
        return this.trans("ponto_status_sync_failed_at", { datetime });
      }
      return this.trans("ponto_status_sync_failed");
    }

    if (isConnectedNoSync) return this.trans("ponto_status_connected");

    if (bankEntry.lastDateOfSuccessfulSync) {
      const datetime = this.formatter.formatTimeAndDate(new Date(bankEntry.lastDateOfSuccessfulSync));
      const count = bankEntry.lastCountOfCreatedPayments ? bankEntry.lastCountOfCreatedPayments : 0;
      return this.trans("ponto_count_of_created_payments", { count, datetime });
    }

    return null;
  }

  private renderPontoConnectNoBankAccountDialog(): any {
    if (!this.state.showConnectNoBankAccountDialog) return null;
    return (
      <PromptDialog
        {...this.props}
        title={this.trans("ponto_no_default_bank_account_title")}
        content={<p>{this.trans("ponto_no_default_bank_account_body")}</p>}
        openLeavePrompt={true}
        positiveButtonLabel={this.trans("ponto_auth_close_button")}
        onSave={() => this.setState({ showConnectNoBankAccountDialog: false })}
        onDiscard={() => this.setState({ showConnectNoBankAccountDialog: false })}
        onlyPositiveButton={true}
      />
    );
  }

  private renderPontoAuthRequiredDialog(): any {
    const required = this.props?.app?.pontoIntegrationRequired;
    if (!required) return null;

    const accountId = this.getPontoAccountId();
    const reason = required.reason;

    let titleKey = "ponto_auth_no_integration_title";
    let bodyKey = "ponto_auth_no_integration_body";

    if (reason === "integration_disconnected") {
      titleKey = "ponto_auth_reconnect_title";
      bodyKey = "ponto_auth_reconnect_body";
    } else if (reason === "authorization_expired") {
      titleKey = "ponto_auth_expired_title";
      bodyKey = "ponto_auth_expired_body";
    } else if (reason === "bank_connection_required") {
      titleKey = "ponto_auth_bank_required_title";
      bodyKey = "ponto_auth_bank_required_body";
    }

    return (
      <PromptDialog
        {...this.props}
        title={this.trans(titleKey)}
        content={<p>{this.trans(bodyKey, { accountId })}</p>}
        openLeavePrompt={true}
        negativeButtonLabel={this.trans("ponto_auth_close_button")}
        positiveButtonLabel={this.trans("ponto_auth_button")}
        prioritizeClosing={true}
        onDiscard={this.closePontoAuthRequiredDialog}
        onSave={() => this.navigateToPontoAuth(required.authUrl)}
      />
    );
  }

  private renderPontoAuthInProgressDialog(): any {
    const inProgress = this.props?.app?.pontoIntegrationInProgress;
    if (!inProgress) return null;

    return (
      <PromptDialog
        {...this.props}
        title={this.trans("ponto_auth_in_progress_title")}
        content={
          <p>{this.trans("ponto_auth_in_progress_body")}</p>
        }
        openLeavePrompt={true}
        negativeButtonLabel={this.trans("ponto_auth_close_button")}
        positiveButtonLabel={this.trans("ponto_auth_restart_button")}
        prioritizeClosing={true}
        onDiscard={this.closePontoAuthInProgressDialog}
        onSave={() => this.navigateToPontoAuth(inProgress.authUrl)}
      />
    );
  }

  private getPontoTranslationKeysForErrorId(errorId: string): { titleKey: string; bodyKey: string } {
    const titleKey = `${errorId}_title`;
    const candidate = Translator.trans(titleKey, {}, "", false);
    if (candidate.indexOf("[MISSING]") === 0) {
      Log.warn("Unrecognized Ponto error id — fallback dialog used", {
        errorId,
        bankAccountId: this.getPontoDefaultBankAccount()?.id,
      });
      return { titleKey: "ponto_unexpected_error_title", bodyKey: "ponto_unexpected_error_body" };
    }
    return { titleKey, bodyKey: `${errorId}_body` };
  }

  private renderPontoSyncErrorDialog(): any {
    const errorId = this.props?.app?.pontoSyncError;
    if (!errorId) return null;

    const { titleKey, bodyKey } = this.getPontoTranslationKeysForErrorId(errorId);

    return (
      <PromptDialog
        {...this.props}
        title={this.trans(titleKey)}
        content={<p>{this.trans(bodyKey, { accountId: this.getPontoAccountId() })}</p>}
        openLeavePrompt={true}
        positiveButtonLabel={this.trans("ponto_auth_close_button")}
        onSave={this.closePontoSyncErrorDialog}
        onDiscard={this.closePontoSyncErrorDialog}
        onlyPositiveButton={true}
      />
    );
  }

  private renderPontoRevokeErrorDialog(): any {
    const errorId = this.props?.app?.pontoRevokeError;
    if (!errorId) return null;

    const { titleKey, bodyKey } = this.getPontoTranslationKeysForErrorId(errorId);

    return (
      <PromptDialog
        {...this.props}
        title={this.trans(titleKey)}
        content={<p>{this.trans(bodyKey, { accountId: this.getPontoAccountId() })}</p>}
        openLeavePrompt={true}
        positiveButtonLabel={this.trans("ponto_auth_close_button")}
        onSave={this.closePontoRevokeErrorDialog}
        onDiscard={this.closePontoRevokeErrorDialog}
        onlyPositiveButton={true}
      />
    );
  }

  private renderCardHeader(isPontoConnected: boolean, pontoStatusLine: string | null): any {
    return (
      <div className="card-header">
        <div className="card-header-row">
          <div className="card-header-title-column">
            <div className="card-header-title">
              {this.trans("title-payments-unused-dashboard")}
            </div>
            <div className="card-header-subtitle">{this.trans("dashboard-payments/subtitle")}</div>
          </div>
          <div className="card-header-actions-column">
            <div className="card-header-actions-row">
              <Button
                color="primary"
                variant="outlined"
                style={{marginRight: "20px"}}
                onClick={() => this.redirect("/app/finance/payment")}
              >
                {this.trans("link-to-all-payments")}
              </Button>
              {!isPontoConnected && (
                <Button
                  variant="outlined"
                  color="primary"
                  style={{marginRight: "20px"}}
                  onClick={this.handlePontoConnectClick}
                  disabled={this.state.isPontoRequesting}
                >
                  {this.trans("connect-to-ponto-button")}
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                style={{marginRight: "20px"}}
                onClick={() => {
                  if (this.checkProcessIsBusy({ action: "create", entityName: "payment" })) {
                    this.openIsBusyPopup();
                  } else {
                    this.openPaymentCreatePopup();
                  }
                }}
              >
                {this.trans("button-add-payment")}
              </Button>
              {!isPontoConnected && (
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.openBankTransactionsDilaog}
                >
                  {this.trans("upload-mt940-file")}
                </Button>
              )}
              {isPontoConnected && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handlePontoSyncClick}
                  disabled={this.state.isPontoRequesting}
                >
                  {this.trans("syncronize-with-ponto-button")}
                </Button>
              )}
              {isPontoConnected && (
                <div>
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={e => this.setState({
                      pontoAnchorEl: e?.currentTarget,
                      openPontoMenu: true,
                    })}
                  >
                    <div className="icon icon-ic-more-vert"></div>
                  </IconButton>
                  <Menu
                    id="ponto-panel-menu"
                    anchorEl={this.state.pontoAnchorEl}
                    open={Boolean(this.state.pontoAnchorEl) && this.state.openPontoMenu}
                    onClose={() => this.setState({ pontoAnchorEl: null, openPontoMenu: false })}
                    disableAutoFocusItem={true}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                    getContentAnchorEl={null}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Button
                        style={{ margin: "5px 10px" }}
                        variant="contained"
                        onClick={this.handlePontoRevokeAccess}
                      >
                        {this.trans("revoke-access-from-ponto-button")}
                      </Button>
                      <Button
                        style={{ margin: "5px 10px" }}
                        color="primary"
                        variant="contained"
                        onClick={() => {
                          this.setState({ pontoAnchorEl: null, openPontoMenu: false });
                          this.openBankTransactionsDilaog();
                        }}
                      >
                        {this.trans("upload-mt940-file")}
                      </Button>
                    </div>
                  </Menu>
                </div>
              )}
            </div>
            {pontoStatusLine !== null && (
              <div className="card-header-status">
                {pontoStatusLine}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  public render() {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    const bankAccounts = this.getAgencyBankAccounts();
    const defaultBankAccount = (bankAccounts || []).find((a: any) => a?.isDefault) || null;
    const pontoIntegration = this.props?.app?.pontoIntegration;
    const bankEntry = defaultBankAccount && pontoIntegration?.bankAccounts
      ? pontoIntegration.bankAccounts.find((e: any) => e.id === defaultBankAccount.id) || null
      : null;
    const isPontoConnected = !!bankEntry && pontoIntegration?.status !== "disconnected";
    const pontoRedirectError = this.state?.pontoRedirectError;
    const pontoStatusLine = this.renderPontoStatusLine();

    return (
      <div className="state-app">
        <div className={`box box-full component-dashboard has-general-page-header with-tabs bottom-whitespace ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent
              activeTab={4}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              {this.renderCardHeader(isPontoConnected, pontoStatusLine)}
              <div>
              <div>
                  <div
                    className="list-filters-wrapper"
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center"
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.includeSnoozedFilter}
                            onChange={this.changeIncludeSnoozedFilter}
                            color="primary"
                          />
                        }
                        label={`${this.trans("label-include-snoozed-payments")} ${this.state.unusedSnoozedPaymentsCount > 0 ? `(${this.state.unusedSnoozedPaymentsCount})` : ""}`}
                      />
                    </div>
                  </div>    
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator
                  }}
                  className="listing-table dashboard-unused-listing-table with-first-border"
                  rows={this.getPayments()}
                  rowsLength={this.getAmountsOfFilteredPayments(this.state.filter)}
                  subtitle={this.trans("title-no-payments-to-list-without-button")}
                  fetch={this.fetchPayments}
                  isFetching={this.state.isFetching}
                  filtering={this.state.filterValue?.length > 0}
                  headers={[
                    "", this.trans("date"), this.trans("description"), "", "", "", "", this.trans("label-amount"), ""
                  ]}
                />
              </div>
            </Card>
          </div>
        </div>

        <SnoozeDialog 
          {...this.props}
          entity={this.state.selectedPayment}
          isOpen={this.state.snoozePaymentDialogOpen}

          fetchFirstUnusedPayments={() => this.fetchFirstUnusedPayments()}
          closeDialog={() => {
            this.setState({
              snoozePaymentDialogOpen: false,
              isSaving: false, 
              anchorEl: null
            })
          }}
        />

        <UndoSettleWithSavingsDialog 
          {...this.props}
          entity={this.selectedPayment}
          isOpen={this.state.isUndoSavingsPopupOpen}

          initializePage={() => {
            this.fetchFirstUnusedPayments();
          }}
          closeDialog={() => this.setState({ isUndoSavingsPopupOpen: false, anchorEl: null })}
        /> 

        <DeleteEntityPrompt
          {...this.props}
          entityName={this.state.paymentToDelete?.hasTransaction? "dialog-info/removetransaction" : "title-payment-delete-from-payment-page-content-dialog"}
          isOpen={this.state.isPaymentRemovePopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"title-payment-unsettle-from-charge-page-content-dialog"}
          isOpen={this.state.isPaymentUnSettlePopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.unSettle}
          type="button-unsettle"
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"title-payment-unlink-from-payment-page-content-dialog"}
          isOpen={this.state.isPaymentUnlinkPopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.unlink}
          type="button-unlink"
        />

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo 
                {...this.props}
                entity={this.state.paymentToAddNote}
                saveDraft={this.saveDraft}
                relations={{ paymentId: this.state.paymentToAddNote?.id }}
                fetchEntities={() => {
                  this.props.dispatch({
                    type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
                  });

                  this.fetchFirstUnusedPayments();
                }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.paymentToAddNote)}
          hideCross={true}
          subtitle={this.state.paymentToAddNote && this.state.paymentToAddNote.displayName ?
            this.state.paymentToAddNote.displayName : ""}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
            <div>
              <span>{this.trans("title-remove-savings-payment-warning")}</span>
            </div>}
          openLeavePrompt={this.state.cannotDeleteSavingsPaymentDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({cannotDeleteSavingsPaymentDialog: false})}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isBankTransactionsDilaogOpen}
          title={this.trans("title-attention") + "!"}
          content={(
            <div>
              <div>
                {this.trans("preprocess/selectbanktransactionfile-info")}
              </div>
              <div style={{display: "flex", justifyContent: "flex-end"}}>
                <Button
                  color="primary"
                  style={{
                    marginRight: "7px",
                    position: "relative",
                    zIndex: 2
                  }}
                  onClick={() => {this.setState({isBankTransactionsDilaogOpen: false})}}
                >
                  {this.trans("dialog-button/cancel")}
                </Button>
                <input
                  type="file"
                  accept=".STA, .940"
                  style={{
                    display: "none"
                  }}
                  multiple={false}
                  onChange={this.upload}
                  id="button-file"
                  ref={this.fileInput}
                />
                <label htmlFor="button-file">
                  <Button
                    variant="contained"
                    color="primary"
                    className={"new-attachment-button"}
                    onClick={() => this.fileInput.current.click()}
                  >
                    {this.trans("dialog-button/selectmt940file")}
                  </Button>
                </label>
              </div>
            </div>
          )}
          onClose={this.closeBankTransactionsDialog}
          withoutDefaultDilaogButtons={true}
        />

        {pontoRedirectError && (
          <PromptDialog
            {...this.props}
            title={this.trans(`${pontoRedirectError.type}_title`)}
            content={
              <p>
                {this.trans(`${pontoRedirectError.type}_body`, {
                  accountId: defaultBankAccount?.accountId || ""
                })}
                {pontoRedirectError.description && ` (${pontoRedirectError.description})`}
              </p>
            }
            openLeavePrompt={true}
            positiveButtonLabel={this.trans("ponto_auth_close_button")}
            onSave={() => this.setState({ pontoRedirectError: null })}
            onDiscard={() => this.setState({ pontoRedirectError: null })}
            onlyPositiveButton={true}
          />
        )}

        <PromptDialog
          {...this.props}
          title={!!fileDetails && fileDetails.state === 3 ? this.trans("processing-file") : (!!fileDetails && fileDetails.title) || this.trans("uploading")}
          content={this.renderDialogContent()}
          openLeavePrompt={this.state.isDialogOpen}
          onSave={this.closeDialog}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          actions={
            [
              <Button
                variant="contained"
                color="primary"
                disabled={!!fileDetails && fileDetails.disableButton}
                onClick={this.continue}
              >
                {this.trans("button-close")}
              </Button>
            ]
          }
        />

        <PaymentCreateDialog
          {...this.props}
          isOpened={this.state.isPaymentCreatePopupOpen}
          title={this.trans("title-new-payment")}
          onCancel={() => this.setState({ isPaymentCreatePopupOpen: false })}
        />

        {this.renderPontoConnectNoBankAccountDialog()}
        {this.renderPontoAuthRequiredDialog()}
        {this.renderPontoAuthInProgressDialog()}
        {this.renderPontoSyncErrorDialog()}
        {this.renderPontoRevokeErrorDialog()}

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    units: state.units,
    payments: state.payments,
    component: state.bankTransactions,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Unused
);
